import { useGetListingAlias } from './routes';
import type { CappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics_Options } from '@zg-rentals/ts-capps-client-react-query';
import { useCappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics } from '@zg-rentals/ts-capps-client-react-query';

export function useGetListingWebAnalytics(
  options?: Partial<CappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics_Options>,
) {
  const listingAlias = useGetListingAlias();
  return useCappsLandlordPropertyDetailsWebApiHandler_getWebAnalytics(
    {
      listingAlias,
    },
    {
      ...options,
      enabled: !!listingAlias,
    },
  );
}
